import { createFileRoute } from '@tanstack/react-router'

import GapoktanPage from '@/components/pages/backoffice/_klb-petani/_gapoktan/containers/GapoktanPage'

export const Route = createFileRoute('/_backoffice/klb-petani/gapoktan/')({
  component: GapoktanPage
})
